// extracted by mini-css-extract-plugin
export default {"menuBlock":"DF-z","title":"EF-z","nav":"FF-z","flexCell":"GF-z","facetLink":"HF-z"};